export const SAVE_SEARCH_MODAL = "email-retention-modal";

export const EMAIL_RETENTION_POPUP_MOBILE = "#email-retention__popup-mobile";

export const EMAIL_RETENTION_POPUP_MOBILE_FORM = "#email-retention__popup-mobile__form";

export const EMAIL_RETENTION_POPUP_MOBILE_CLOSE_ICON = "#email-retention__popup-mobile__close";

export const EMAIL_RETENTION_POPUP_MOBILE_CLOSE_BUTTON = "#close-retention-popup-mobile";

export const EMAIL_RETENTION_MOBILE_SAVE_ALERT_CTA = "#save-alert-cta";

export const EMAIL_RETENTION_FORM_IDS = [
    "save-email-retention-form",
    "js-email-retention-form",
    "js-email-retention-form-modal",
    "js-email-retention-form-traffic",
];

export const EMAIL_RETENTION_TOGGLE_IDS = EMAIL_RETENTION_FORM_IDS.map(formId => `${formId}__toggle-accept-news`);

export const EMAIL_RETENTION_ALERTS_LOCAL_STORAGE_KEY = "savedSearches";
export const EMAIL_RETENTION_VISITED_LOCATIONS_LOCAL_STORAGE_KEY = "visitedSearches";
